module.exports = __webpack_public_path__ + "img/kosciol2_galeria.4d4a6cb4.jpg";